module.exports = __webpack_public_path__ + "static/braincandy-e8e6c221a1597984b46d1152f0782ee7.jpg";